import getPublisherInfo from './get-publisher-info';
import { settings } from './setup';

export default {
  getPublisherInfo,
  settings,
};
